export function getAccessToken(): string | undefined {
  const auth0Key = Object.keys(localStorage).find(x =>
    x.includes('@@auth0spajs@@')
  );
  return (
    auth0Key &&
    (JSON.parse(localStorage.getItem(auth0Key))?.body?.access_token as string)
  );
}
